var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcessTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99333 1.33398C4.31333 1.33398 1.33333 4.32065 1.33333 8.00065C1.33333 11.6807 4.31333 14.6673 7.99333 14.6673C11.68 14.6673 14.6667 11.6807 14.6667 8.00065C14.6667 4.32065 11.68 1.33398 7.99333 1.33398ZM8 13.334C5.05333 13.334 2.66666 10.9473 2.66666 8.00065C2.66666 5.05398 5.05333 2.66732 8 2.66732C10.9467 2.66732 13.3333 5.05398 13.3333 8.00065C13.3333 10.9473 10.9467 13.334 8 13.334Z",
    fill: "#5B5D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 4.66602H7.33333V8.66602L10.8333 10.766L11.3333 9.94602L8.33333 8.16602V4.66602Z",
    fill: "#5B5D65"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcessTime);
export default __webpack_public_path__ + "static/media/acess_time.81b815be71c7e628a50f3e20838f9731.svg";
export { ForwardRef as ReactComponent };